import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import { Organizer } from '../../../utils/types';
import GoogleRating from '../../GoogleRating';
import './CampOrganizerSection.css';

interface CampOrganizerSectionProps {
  organizer: Organizer;
  className?: string;
}

const CampOrganizerSection: React.FC<CampOrganizerSectionProps> = ({ organizer, className = '' }) => {
  const defaultDescription = `${organizer.name} is a trusted provider of quality camp experiences for children.`;

  return (
    <div className={`camp-organizer-section ${className}`}>
      <h2 className="camp-organizer-title">About {organizer.name}</h2>
      <div className="camp-organizer-content">
        <div className="camp-organizer-description">
          <ReactMarkdown rehypePlugins={[rehypeSanitize]}>
            {organizer.description || defaultDescription}
          </ReactMarkdown>
        </div>

        <div className="camp-organizer-info">
          {organizer.google_rating && organizer.google_rating_count && organizer.google_maps_place_id && (
            <div className="camp-organizer-rating">
              <GoogleRating
                rating={organizer.google_rating}
                reviewCount={organizer.google_rating_count}
                googlePlacesId={organizer.google_maps_place_id}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampOrganizerSection;
